const settings = {
  pwa: true,
  title: '8',
  logo: '/logo.svg',
} as const;

export default settings;
